/***
 *
 *   CHIP
 *   Small metadata chip — soft tinted surface, leading dot, label. Used for
 *   ticket priority and status, where the solid Badge pill is too loud.
 *
 *   Ported from ui-reference/src/components/tickets/ticket-attribute-chip.tsx.
 *
 *   PROPS
 *   label: text to display
 *   tintClass: border + background + text classes
 *   dotClass: solid fill for the leading indicator dot
 *
 **********/

import { cn } from 'components/lib';
import Style, { PRIORITY_STYLES, STATUS_STYLES } from './chip.tailwind.js';

export function Chip(props) {
    return (
        <span className={cn(Style.base, props.tintClass, props.className)} title={props.title}>
            <span className={cn(Style.dot, props.dotClass)} aria-hidden />
            <span className={Style.label}>{props.label}</span>
        </span>
    );
}

/* Priority is a closed set in both the reference and this app. */
export function PriorityChip(props) {
    const styles = PRIORITY_STYLES[props.priority] || PRIORITY_STYLES.low;
    return <Chip label={props.label} tintClass={styles.tint} dotClass={styles.dot} className={props.className} />;
}

/**
 * Status is NOT a closed set here: this app reads an editable, per-category
 * `status_template`, so a key the reference never had is expected. Those fall
 * back to the neutral `closed` treatment rather than losing their chip.
 */
export function StatusChip(props) {
    const styles = STATUS_STYLES[props.status] || STATUS_STYLES.closed;
    return <Chip label={props.label} tintClass={styles.tint} dotClass={styles.dot} className={props.className} />;
}

export { PRIORITY_STYLES, STATUS_STYLES };
